<template>
<v-form v-model="valid">
    <v-container>
        <v-row>
            <v-col cols="12" md="12">
                <h1>Center ({{ center.name }})</h1>

                <v-simple-table>
                    <template v-slot:default>
                        <tbody>
                            <tr>
                                <td>Name</td>
                                <td>
                                    <FormulateInput type="text" name="Center Name" v-model="center.name" />
                                </td>
                            </tr>
                            <tr>
                                <td>Adress</td>

                                <td>
                                    <FormulateInput type="text" name="Center Name" v-model="center.address" />
                                </td>
                            </tr>
                            <tr>
                                <td>Zip</td>
                                <td>
                                    <FormulateInput type="text" name="Zip" v-model="center.zip" />
                                </td>
                            </tr>
                            <tr>
                                <td>City</td>

                                <td>
                                    <FormulateInput type="text" name="City" v-model="center.city" />
                                </td>
                            </tr>
                            <tr>
                                <td>Center Email</td>
                                <td>
                                    <FormulateInput type="email" name="Center Email" validation="required|email" v-model="center.contactEmail" />
                                </td>
                            </tr>
                            <tr>
                                <td>Center contact Name</td>

                                <td>
                                    <FormulateInput type="text" name="Center Contact Name" v-model="center.contactName" />
                                </td>
                            </tr>
                            <tr>
                                <td>Center contact Phone</td>

                                <td>
                                    <FormulateInput type="text" name="Center Contact Phone" v-model="center.contactPhone" />
                                </td>
                            </tr>
                            <tr>
                                <td>Center Visible in Calender</td>

                                <td>
                                    <FormulateInput type="checkbox" v-model="center.visible" />
                                </td>
                            </tr>
                              <tr>
                                <td>Auto Fill Schedule in Calender</td>

                                <td>
                                    <FormulateInput type="checkbox" v-model="center.autoFillSchedules" />
                                </td>
                            </tr>
                            
                        </tbody>
                    </template>
                </v-simple-table>

                <hr />
                <h2>Center Rooms</h2>
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">Room</th>

                                <th class="text-left">Schedules</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="room in center.rooms" :key="room.rowKey">
                                <td>
                                    <v-form ref="form">
                                        <v-text-field v-model="room.name" label="Name"></v-text-field>
                                        <v-text-field type="number" v-model="room.spots" label="Spots"></v-text-field>
                                        <v-text-field type="number" v-model="room.hoursToReservation" label="Hours before reservation"></v-text-field>
                                        <v-checkbox  v-model="room.unattendedAccess" label="Unattended Access (6-22)"></v-checkbox>
                                    </v-form>
                                </td>
                                <td>
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">Day</th>
                                                    <th class="text-left">OpenningHour</th>
                                                    <th class="text-left">ClosingHour</th>
                                                </tr>
                                            </thead>
                        <tbody>
                            <tr v-for="scheduleHour in room.scheduleHours" :key="scheduleHour.day">
                                <td>{{ scheduleHour.day | dayOfWeekAsString}}</td>
                                <td>
                                    <FormulateInput type="number" name="OpenningHour" v-model="scheduleHour.openningHour" />
                                </td>
                                <td>
                                    <FormulateInput type="number" name="ClosingHour" v-model="scheduleHour.closingHour" />
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                </td>
                </tr>
                </tbody>
                </template>
                </v-simple-table>
                <hr>
                <v-btn :disabled="!valid" color="success" class="mr-4" @click="save">Save Center</v-btn>

            </v-col>
        </v-row>

        <v-snackbar v-model="showSnackbar" :multi-line="false" :timeout="5000" dark color="#EE765E" class="title">
            {{ snackbarText }}
            <v-btn color="white" text @click="showSnackbar = false">Luk</v-btn>
        </v-snackbar>
    </v-container>
</v-form>
</template>

<script>
// import {    EventBus} from './../../event-bus.js';

//import store from "./../../store";
import core from "./../../mixins/core";

import Vue from "vue";
import VueFormulate from "@braid/vue-formulate";
Vue.use(VueFormulate);

export default {
    data: function () {
        return {
            center: false,
            showSnackbar: false,
            snackbarText: "",
            valid: true,
            user: {
                email: "",
                firstName: "",
                lastName: "",
            },
            nameRules: [
                //   v => !!v || 'Name is required',
                //   v => v.length <= 10 || 'Name must be less than 10 characters',
            ],
            emailRules: [
                (v) => !!v || "E-mail is required",
                (v) => /.+@.+/.test(v) || "E-mail must be valid",
            ],
        };
    },
    mixins: [core],
    mounted() {
        this.fetchCenter(this.$route.params.id).then((center) => {
            this.center = center;
            this.center.visible = this.center.state == "Visible";
        });
    },
    methods: {
        save() {
            this.center.state = "false";
            if (this.center.visible)
                this.center.state = "Visible";
            this.addUpdateCenter(this.center).then((center) => {
                //store.commit("setUser", user);
                this.center = center;
                this.showSnackbar = true;
                this.snackbarText = "Center saved";
            });
        },
    },
    name: "Center",
};
</script>
